import React, { useEffect, useState } from "react";
import "./pages.css";
import jazz from "../../assets/jazz.jpg";
import bluss from "../../assets/bluss.jfif";
import guitar from "../../assets/guitar.jpg";
import { useSelector } from "react-redux";
import api from "../../utilis/api";

const Overview = () => {
  const [bookedSlots, setBookedSlots] = useState([]);

  const { user } = useSelector((state) => state.auth);
  const fetchBookedSlots = async () => {
    try {
      const res = await api.get("/booking", {
        params: { studentId: user._id },
      });
      if (res.data.success) {
        setBookedSlots(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch booked slots:", err);
    }
  };

  useEffect(() => {
    if (user && user._id) fetchBookedSlots();
  }, [user]);
  const today = new Date();
  const upcomingSlots = bookedSlots.filter(
    (slot) => new Date(slot.date) >= today && slot.status === "confirmed",
  );

  const completedSlots = bookedSlots.filter(
    (slot) => new Date(slot.date) < today || slot.status === "completed",
  );

  return (
    <div className="overview-container">
      {/* Header */}
      <header className="overview-header">
        <div className="header-text">
          <span className="header-subtitle">Welcome Back, Robert</span>
          <h1 className="header-title">Student Dashboard</h1>
        </div>
      </header>

      {/* Dashboard Grid */}
      <div className="overview-grid">
        {/* Courses */}

        <section className="cards">
          <h3>Upcoming Sessions</h3>
          {upcomingSlots && upcomingSlots.length > 0 ? (
            <ul className="activities-list">
              {upcomingSlots.map((slot, i) => (
                <li key={i}>
                  {slot.teacherId.userId.name} -{" "}
                  {new Date(slot.date).toLocaleDateString()} at {slot.time}
                </li>
              ))}
            </ul>
          ) : (
            <p>No Upcoming Slots</p>
          )}
        </section>

        <section className="cards ">
          <h3>Completed Sessions</h3>
          {completedSlots && completedSlots.length > 0 ? (
            <ul className="activities-list">
              {completedSlots.map((slot, i) => (
                <li key={i}>
                  {slot.teacherId.userId.name} -{" "}
                  {new Date(slot.date).toLocaleDateString()} at {slot.time}
                </li>
              ))}
            </ul>
          ) : (
            <p>No Completed Slots</p>
          )}
        </section>
      </div>
    </div>
  );
};

export default Overview;
